import type { NeverFunc } from "@suse-o11y/never-func";
import { unpurry } from "@suse-o11y/unpurry";
import { isShallowEqual as isShallowEqual_ } from "remeda";

export const isShallowEqual = unpurry(isShallowEqual_, 2) as typeof isShallowEqual_ & NeverFunc;
